module.exports = __webpack_public_path__ + "img/protocol-rejected.0f8dba4c.svg";